import { useMemo } from "react";
import actions from "../actions/pla.action";
import { usePLADispatch } from "../contexts/pla.context";
const { INIT_PLA, UPDATE_PLA } = actions;

const usePLAController = () => {
  const dispatch = usePLADispatch();
  return useMemo(
    () => ({
      initPLA: context => dispatch({ type: INIT_PLA, payload: context }),
      updatePLA: plaFlag => dispatch({ type: UPDATE_PLA, payload: plaFlag })
    }),
    [dispatch]
  );
};

export default usePLAController;
